module.exports = __webpack_public_path__ + "img/active-upArrow.b19ab516.svg";